<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="medicoObsModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Observação</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info">
                            {{ $util.getFormatDate(dt_data) }}
                        </div>

                        <az-input 
                            v-model="obs" 
                            label="Observação" 
                            type="textarea" 
                            rows="3"
                            required
                            :validate="validate"></az-input>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit class="btn btn-primary" @click="atualizar()">Incluir</az-submit>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() {
        return {
            id_medico: null, 
            dt_data: null,      
            validate: false, 
            obs: "", 
        }
    },
    components: {
        AzInput,
        AzSubmit
    },

    methods: { 
        abrir(id_medico, dt_data) {
            this.validate = false; 
            this.id_medico = id_medico;
            this.dt_data = dt_data;
            this.obs = ""; 

            $('#medicoObsModal').modal('show');
        },

        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'medico_obss',
                func: 'store',
                dados: { 
                    id_medico: this.id_medico, 
                    dt_data: this.dt_data, 
                    st_texto: this.obs, 
                    fl_callcenter: true,
                    fl_recepcao: false, 
                },
                modal: 'medicoObsModal',
                toast: true,
                callback: res => {
                    this.$emit('refresh');
                }
            });
        }
    }
}
</script>
